import React from 'react';
import { motion } from 'framer-motion';
import { Building2, ShoppingCart, Landmark, Users, Coins } from 'lucide-react';
const solutions = [{
  id: 'fintech-psp',
  title: 'Fintech & PSP Infrastructure',
  icon: Building2,
  description: 'Regulated financial products across multiple markets'
}, {
  id: 'marketplaces',
  title: 'Marketplaces & Platforms',
  icon: ShoppingCart,
  description: 'Multi-party collections, splits, and payouts'
}, {
  id: 'treasury',
  title: 'Global Treasury & Multinationals',
  icon: Landmark,
  description: 'Centralized treasury and FX optimization'
}, {
  id: 'payroll',
  title: 'Payroll & Mass Payouts',
  icon: Users,
  description: 'Distributed team and contractor payments'
}, {
  id: 'programmable',
  title: 'Programmable & Tokenized Flows',
  icon: Coins,
  description: 'Conditional and rule-based settlement'
}];
export function SolutionsIndex() {
  const handleClick = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="py-16 bg-white" data-id="element-717">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-718">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-12" data-id="element-719">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-720">
            Solutions Overview
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-721">
            Explore how Obseq powers real-world business use cases.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-722">
          {solutions.map((solution, index) => <motion.button key={solution.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} onClick={() => handleClick(solution.id)} className="group bg-white border-2 border-slate-200 rounded-xl p-6 text-center sm:text-left hover:border-blue-500 hover:shadow-lg transition-all flex flex-col items-center sm:items-start" data-id="element-723">
              <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600 mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors" data-id="element-724">
                <solution.icon className="w-6 h-6" data-id="element-725" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-726">
                {solution.title}
              </h3>
              <p className="text-sm text-slate-600" data-id="element-727">{solution.description}</p>
            </motion.button>)}
        </div>
      </div>
    </section>;
}